// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3u_UF","header":"MessagesList_header__3Pr1T","chat":"MessagesList_chat__27k6C"};